(function () {
  'use strict';

  /* =========================================================
     AN DIGITAL LOCK LEARNING HUB
     =========================================================

     This script handles:

     1. Automatic FAQ numbering
     2. Learning Hub search
     3. Automatic search indexing from category pages
     4. Popular Question anchor opening
     5. Search-result FAQ opening
     6. Sticky-header scroll positioning

     FAQ content remains the single source of truth.
     No manual question index is required.
     ========================================================= */


  /* =========================================================
     CATEGORY PAGES
     =========================================================

     These are the 10 permanent Learning Hub categories.

     Adding/removing questions inside these pages requires
     NO JavaScript changes.
     ========================================================= */

  var CATEGORY_PAGES = [
    {
      name: 'Buying Guides & Product Selection',
      url: '/pages/digital-lock-buying-guide'
    },
    {
      name: 'HDB, Fire-Rated Door & Compatibility',
      url: '/pages/hdb-digital-lock-guide'
    },
    {
      name: 'Brand & Model Comparisons',
      url: '/pages/digital-lock-brand-comparisons'
    },
    {
      name: 'Unlocking Methods & Everyday Convenience',
      url: '/pages/digital-lock-unlocking-methods'
    },
    {
      name: 'Security, Privacy & Safety',
      url: '/pages/digital-lock-security'
    },
    {
      name: 'Battery, Lifespan & Maintenance',
      url: '/pages/digital-lock-battery-maintenance'
    },
    {
      name: 'Installation, Handover & After-Sales',
      url: '/pages/digital-lock-installation'
    },
    {
      name: 'Troubleshooting & Preventing Common Problems',
      url: '/pages/digital-lock-troubleshooting'
    },
    {
      name: 'Smart Home, Camera & Connected Features',
      url: '/pages/smart-digital-lock-guide'
    },
    {
      name: 'Why Choose AN Digital Lock',
      url: '/pages/why-an-digital-lock'
    }
  ];


  /* =========================================================
     HELPERS
     ========================================================= */

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }


  /*
     Makes searches such as these behave consistently:

     Wi-Fi       -> wi fi
     wi_fi       -> wi fi
     dual-unlock -> dual unlock
     Dual Unlock -> dual unlock
  */

  function normalizeSearchText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[-_/]+/g, ' ')
      .replace(/[^\p{L}\p{N}\s]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }


  function getQuestionText(details) {
    var question = details.querySelector('.adl-learn__faq-question');

    return question
      ? question.textContent.trim()
      : '';
  }


  function getAnswerText(details) {
    var answer = details.querySelector('.adl-learn__faq-answer');

    return answer
      ? answer.textContent.replace(/\s+/g, ' ').trim()
      : '';
  }


  /* =========================================================
     AUTOMATIC FAQ NUMBERING
     =========================================================

     Every category starts from 001.

     HTML only needs:

     <span class="adl-learn__faq-number"></span>
     ========================================================= */

  function numberFAQQuestions() {
    var lists = document.querySelectorAll('.adl-learn__faq-list');

    lists.forEach(function (list) {
      var questions = list.querySelectorAll('.adl-learn__faq');

      questions.forEach(function (question, index) {
        var numberElement =
          question.querySelector('.adl-learn__faq-number');

        if (!numberElement) {
          return;
        }

        numberElement.textContent =
          String(index + 1).padStart(3, '0');
      });
    });
  }


  /* =========================================================
     FAQ OPENING + SCROLLING
     ========================================================= */

  function openFAQ(details) {
    if (!details) {
      return;
    }

    details.open = true;

    /*
      Short delay allows the accordion height to update before
      scrolling. Your CSS scroll-margin-top handles the header.
    */

    setTimeout(function () {
      details.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 120);
  }


  /* =========================================================
     POPULAR QUESTION / HASH LINKS
     =========================================================

     Example:

     /pages/hdb-digital-lock-guide#fire-rated-door-digital-lock
     ========================================================= */

  function openFAQFromHash() {
    var hash = window.location.hash;

    if (!hash) {
      return false;
    }

    var id;

    try {
      id = decodeURIComponent(hash.substring(1));
    } catch (error) {
      id = hash.substring(1);
    }

    if (!id) {
      return false;
    }

    var target = document.getElementById(id);

    if (
      !target ||
      target.tagName.toLowerCase() !== 'details' ||
      !target.classList.contains('adl-learn__faq')
    ) {
      return false;
    }

    openFAQ(target);

    return true;
  }


  /* =========================================================
     NORMAL SEARCH RESULT LINKS
     =========================================================

     Normal questions do not need IDs.

     Search results use:

     ?faq=QUESTION TEXT

     The destination page finds the matching question,
     opens it, and scrolls to it.
     ========================================================= */

  function openFAQFromQuery() {
    var params =
      new URLSearchParams(window.location.search);

    var requestedQuestion =
      params.get('faq');

    if (!requestedQuestion) {
      return false;
    }

    var targetText =
      normalizeSearchText(requestedQuestion);

    if (!targetText) {
      return false;
    }

    var questions =
      document.querySelectorAll('.adl-learn__faq');

    var exactMatch = null;
    var partialMatch = null;

    questions.forEach(function (details) {
      var questionText =
        normalizeSearchText(getQuestionText(details));

      if (!questionText) {
        return;
      }

      if (questionText === targetText) {
        exactMatch = details;
        return;
      }

      if (
        !partialMatch &&
        (
          questionText.indexOf(targetText) !== -1 ||
          targetText.indexOf(questionText) !== -1
        )
      ) {
        partialMatch = details;
      }
    });

    var target =
      exactMatch || partialMatch;

    if (!target) {
      return false;
    }

    openFAQ(target);

    return true;
  }


  /* =========================================================
     BUILD SEARCH INDEX FROM LIVE CATEGORY PAGES
     ========================================================= */

  var searchIndexPromise = null;


  function loadCategoryQuestions(category) {
    return fetch(category.url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Could not load ' + category.url
          );
        }

        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var documentHTML =
          parser.parseFromString(html, 'text/html');

        var questions =
          documentHTML.querySelectorAll(
            '.adl-learn__faq'
          );

        var items = [];

        questions.forEach(function (details, index) {
          var question =
            getQuestionText(details);

          if (!question) {
            return;
          }

          var answer =
            getAnswerText(details);

          var id =
            details.getAttribute('id');

          var url;

          /*
            Popular Questions already have permanent IDs.
            Keep using their clean anchor URL.
          */

          if (id) {
            url =
              category.url +
              '#' +
              encodeURIComponent(id);
          } else {
            /*
              Ordinary FAQs require no ID.

              Pass the question through the URL so that the
              destination page can locate and open it.
            */

            url =
              category.url +
              '?faq=' +
              encodeURIComponent(question);
          }

          items.push({
            question: question,
            answer: answer,
            category: category.name,
            url: url,
            position: index + 1,
            searchText: normalizeSearchText(
              question +
              ' ' +
              answer +
              ' ' +
              category.name
            )
          });
        });

        return items;
      })
      .catch(function (error) {
        console.warn(
          '[ADL Learning Hub]',
          error.message
        );

        return [];
      });
  }


  function buildSearchIndex() {
    if (searchIndexPromise) {
      return searchIndexPromise;
    }

    searchIndexPromise =
      Promise.all(
        CATEGORY_PAGES.map(loadCategoryQuestions)
      ).then(function (categoryResults) {
        return categoryResults.reduce(
          function (allQuestions, questions) {
            return allQuestions.concat(questions);
          },
          []
        );
      });

    return searchIndexPromise;
  }


  /* =========================================================
     SEARCH RANKING
     ========================================================= */

  function scoreSearchResult(item, searchTerm, words) {
    var question =
      normalizeSearchText(item.question);

    var category =
      normalizeSearchText(item.category);

    var answer =
      normalizeSearchText(item.answer);

    var score = 0;

    /*
      Exact phrase in question gets the strongest weighting.
    */

    if (question.indexOf(searchTerm) !== -1) {
      score += 100;
    }

    /*
      All individual words appearing in the question.
    */

    var allWordsInQuestion =
      words.every(function (word) {
        return question.indexOf(word) !== -1;
      });

    if (allWordsInQuestion) {
      score += 60;
    }

    /*
      Individual question-word matches.
    */

    words.forEach(function (word) {
      if (question.indexOf(word) !== -1) {
        score += 15;
      }

      if (category.indexOf(word) !== -1) {
        score += 5;
      }

      if (answer.indexOf(word) !== -1) {
        score += 2;
      }
    });

    return score;
  }


  function searchQuestions(index, rawTerm) {
    var term =
      normalizeSearchText(rawTerm);

    if (!term) {
      return [];
    }

    var words =
      term.split(' ').filter(Boolean);

    return index
      .filter(function (item) {
        /*
          Require every searched word to appear somewhere
          in the question, answer or category.

          This makes searches such as:

          dual unlocking
          fire rated
          gate sync
          emergency power
          wifi battery

          work naturally.
        */

        return words.every(function (word) {
          return item.searchText.indexOf(word) !== -1;
        });
      })
      .map(function (item) {
        return {
          item: item,
          score: scoreSearchResult(
            item,
            term,
            words
          )
        };
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .slice(0, 30)
      .map(function (result) {
        return result.item;
      });
  }


  /* =========================================================
     SEARCH RESULT UI
     ========================================================= */

  function renderSearchResults(resultsElement, items) {
    resultsElement.hidden = false;

    if (!items.length) {
      resultsElement.innerHTML =
        '<div class="adl-learn__no-results">' +
        'No matching questions found. Try a broader term such as ' +
        '“battery”, “HDB”, “Wi-Fi”, “sync” or “fingerprint”.' +
        '</div>';

      return;
    }

    var resultHTML =
      '<div class="adl-learn__result-count">' +
      items.length +
      (items.length === 30 ? '+' : '') +
      ' matching question' +
      (items.length === 1 ? '' : 's') +
      '</div>';

    resultHTML += items
      .map(function (item) {
        return (
          '<a class="adl-learn__result" href="' +
          escapeHTML(item.url) +
          '">' +

            '<span class="adl-learn__result-content">' +

              '<strong>' +
              escapeHTML(item.question) +
              '</strong>' +

              '<small>' +
              escapeHTML(item.category) +
              '</small>' +

            '</span>' +

            '<span class="adl-learn__result-arrow" aria-hidden="true">' +
            '→' +
            '</span>' +

          '</a>'
        );
      })
      .join('');

    resultsElement.innerHTML =
      resultHTML;
  }


  function renderSearchLoading(resultsElement) {
    resultsElement.hidden = false;

    resultsElement.innerHTML =
      '<div class="adl-learn__no-results">' +
      'Searching the Learning Hub…' +
      '</div>';
  }


  /* =========================================================
     INITIALISE LEARNING HUB SEARCH
     ========================================================= */

  function initialiseLearningHubSearch() {
    var root =
      document.querySelector(
        '[data-adl-learning-hub]'
      );

    if (!root) {
      return;
    }

    var input =
      root.querySelector('[data-adl-search]');

    var results =
      root.querySelector('[data-adl-results]');

    var clear =
      root.querySelector('[data-adl-clear]');

    if (!input || !results) {
      return;
    }

    var searchRequestNumber = 0;


    function clearResults() {
      results.innerHTML = '';
      results.hidden = true;

      if (clear) {
        clear.hidden = true;
      }
    }


    function runSearch() {
      var rawTerm =
        input.value.trim();

      if (!rawTerm) {
        clearResults();
        return;
      }

      if (clear) {
        clear.hidden = false;
      }

      /*
        Ensures results from an older asynchronous search
        cannot overwrite a newer search.
      */

      searchRequestNumber += 1;

      var currentRequest =
        searchRequestNumber;

      renderSearchLoading(results);

      buildSearchIndex()
        .then(function (index) {
          if (
            currentRequest !==
            searchRequestNumber
          ) {
            return;
          }

          var matches =
            searchQuestions(
              index,
              rawTerm
            );

          renderSearchResults(
            results,
            matches
          );
        });
    }


    input.addEventListener(
      'input',
      runSearch
    );


    input.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Escape') {
          input.value = '';

          searchRequestNumber += 1;

          clearResults();

          input.blur();
        }
      }
    );


    if (clear) {
      clear.addEventListener(
        'click',
        function () {
          input.value = '';

          searchRequestNumber += 1;

          clearResults();

          input.focus();
        }
      );
    }
  }


  /* =========================================================
     PAGE INITIALISATION
     ========================================================= */

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      /*
        Number the FAQ questions on category pages.
      */

      numberFAQQuestions();


      /*
        Set up search if this is the main Learning Hub page.
      */

      initialiseLearningHubSearch();


      /*
        Hash anchors take priority because they are your
        permanent Popular Question links.
      */

      var openedFromHash =
        openFAQFromHash();

      if (!openedFromHash) {
        openFAQFromQuery();
      }
    }
  );


  /*
    Handles clicking another anchor while remaining on the
    same page.
  */

  window.addEventListener(
    'hashchange',
    function () {
      openFAQFromHash();
    }
  );


  /*
    Handles browser Back / Forward navigation for ?faq= URLs.
  */

  window.addEventListener(
    'popstate',
    function () {
      if (!openFAQFromHash()) {
        openFAQFromQuery();
      }
    }
  );

})();